import store from '@/store'
import contentTreeStore from '@/store/modules/contentTree.store'

export default async to => {
  if (!to.meta.requiresContentTree) {
    return
  }

  if (!contentTreeStore.state.isLoaded) {
    return new Promise(resolve => {
      store.watch(
        state => state.contentTree.isLoaded,
        loaded => {
          if (loaded) {
            resolve()
          }
        }
      )
    })
  }
}
